import { ReportStatusEnum, ReportSubsystemType, ReportSystemType } from "../../types";

export const getSubsystemStatusColor = (status: string) => {
  switch (status) {
    case 'inspected':
      return 'success';
    case 'not_started':
      return 'warning';
    case 'error':
      return 'error';
    case 'in_progress':
      return 'info';
    case 'completed':
      return 'success';
    default:
      return 'default';
  }
}

/**
 * Check if the subsystem should be hidden
 * @param subsystem The subsystem to check
 * @returns true if the subsystem should be shown, false if it should be hidden
 */
export const hideSubsystem = (subsystem: ReportSubsystemType): boolean => {
  const isIncludedOnReport = subsystem.includeOnReport;
  if (!isIncludedOnReport) {
    return false;
  }
  if (subsystem?.status === ReportStatusEnum.NotPresent) {
    return !!subsystem.includeOnReportIfNotPresent;
  }

  const hasNote = !!(subsystem.note && subsystem.note?.length > 0);
  const hasLimitations = (subsystem.reportLimitations?.length || 0) > 0;
  const hasAttachments = (subsystem.reportAttachments?.length || 0) > 0;
  const hasDeficiencies = (subsystem.reportDeficiencies?.length || 0) > 0;

  return hasNote || hasLimitations || hasAttachments || hasDeficiencies || isIncludedOnReport;
};

export const includeSystemSubSystems = (system: ReportSystemType) =>
  system.includeOnReport;
